<script lang="ts">
  import {createEventDispatcher} from 'svelte';

  let progressEl: any = null;

  export const getProgressElement = () => {
    return progressEl;
  };

  const dispatch = createEventDispatcher();

  export const changeRunnerColor = (runnerElement: any) => {
    const min = runnerElement.min;
    const max = runnerElement.max;
    const val = runnerElement.value;

    runnerElement.style.backgroundSize = ((val - min) * 100) / (max - min) + '% 100%';
  };

  const handleInputChange = (e: any) => {
    let target = e.target;
    changeRunnerColor(target);
    dispatch('progress-change', {value: e.target.value});
  };

  window.addEventListener('reset-timeline', () => {
    if (progressEl) {
      progressEl.value = 0;
      dispatch('progress-change', {value: 0});
      handleInputChange({target: progressEl});
    }
  });
</script>

<div class="flex flex-grow items-center px-3">
  <input
    on:change={handleInputChange}
    on:input={handleInputChange}
    bind:this={progressEl}
    step=".001"
    type="range"
    min="0"
    max="99.5"
    value="0"
  />
</div>

<style lang="postcss">
  input {
    -webkit-appearance: none;
    background-size: 0% 100%;
    background-repeat: no-repeat;
    @apply h-1 w-full rounded bg-gray-300 bg-gradient-to-r from-primary to-primary-600;
  }

  input::-webkit-slider-thumb {
    -webkit-appearance: none;
    @apply h-4 w-4 rounded-full bg-primary shadow-md;
  }

  input::-webkit-slider-runnable-track {
    -webkit-appearance: none;
    @apply bg-transparent;
  }
</style>
